@if (form()) {
  <div class="flex-column">
    <div class="flex-row align-center mat-h2 gap-sm">
      Verbuchungsoptionen
      @for (action of actions(); track action.controlAction) {
        <lib-dynamic-form-action
          [hideLabel]="true"
          [action]="action"
          (callActionFunction)="callActionFunction($event)"
        />
      }
    </div>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Mandant & Abschluss</div>
      <lib-help-icon (click)="showHelpForTenant()"/>
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.tenantNumber]"
      [formData]="formData.tenantNumber()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.lastAnnualFinancialStatements]"
      [formData]="formData.lastAnnualFinancialStatements()"
    />

    <br>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Debitoren-Konten</div>
      <lib-help-icon (click)="showHelpForDebitor()"/>
    </div>
    <mat-divider/>

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.debitorAccountDiverse]"
        [formData]="formData.debitorAccountDiverse()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.debitorSepa]"
        [formData]="formData.debitorSepa()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.debitorAccountUnknown]"
        [formData]="formData.debitorAccountUnknown()"
      />
    </div>

    <br>

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.invoiceNumber]"
        [formData]="formData.invoiceNumber()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.collectiveInvoiceNumber]"
        [formData]="formData.collectiveInvoiceNumber()"
      />
    </div>

    <br>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Buchhaltungsaggregationen</div>
      <lib-help-icon (click)="showHelpForAccountingAggregation()"/>
    </div>
    <mat-divider/>
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.cancelRequestMode]"
      [formData]="formData.cancelRequestMode()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.creditAggregation]"
      [formData]="formData.creditAggregation()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.debitAggregation]"
      [formData]="formData.debitAggregation()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.swapName]"
      [formData]="formData.swapName()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.noInvoiceNumberInTransactionText]"
      [formData]="formData.noInvoiceNumberInTransactionText()"
    />
    <br>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Export-Optionen</div>
      <lib-help-icon (click)="showHelpForExportOptions()"/>
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.exportJournal]"
      [formData]="formData.exportJournal()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.invoiceExport]"
      [formData]="formData.invoiceExport()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.monthlyFileExport]"
      [formData]="formData.monthlyFileExport()"
    />

    <br>


    <div class="flex-row align-center space-between">
      <div class="mat-h3">Schnittstellenkonfiguration</div>
      <lib-help-icon (click)="showHelpForInterfaceConfig()"/>
    </div>
    <mat-divider/>

    <mat-tab-group>
      <mat-tab label="Diamant">
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.diamondDocumentType]"
          [formData]="formData.diamondDocumentType()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.diamondDocumentTypeCreditMemo]"
          [formData]="formData.diamondDocumentTypeCreditMemo()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.diamondExtendedFDataset]"
          [formData]="formData.diamondExtendedFDataset()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.diamondInvoiceDateAsReceiptDate]"
          [formData]="formData.diamondInvoiceDateAsReceiptDate()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.diamondSDatasetExport]"
          [formData]="formData.diamondSDatasetExport()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.dunningType]"
          [formData]="formData.dunningType()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.paymentTerm]"
          [formData]="formData.paymentTerm()"
        />
      </mat-tab>
      <mat-tab label="EXTF">
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.addColumnDescriptions]"
          [formData]="formData.addColumnDescriptions()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.extfConsultantNumber]"
          [formData]="formData.extfConsultantNumber()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.extfGlAccountLength]"
          [formData]="formData.extfGlAccountLength()"
        />
      </mat-tab>
      <mat-tab label="Micos">
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.votingCircle]"
          [formData]="formData.votingCircle()"
        />
        <kpi4me-form-element
          [formControlElement]="form().controls[EFormKeys.constCenter]"
          [formData]="formData.constCenter()"
        />
      </mat-tab>
    </mat-tab-group>
  </div>
}
<input
  #fileUpload
  style="display: none"
  type="file"
  accept=".json"
  (change)="uploadJson($event).subscribe()"
/>
